import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProcessingPaymentSliceState } from "../../types/store";
import { ProcessingPaymentState } from "../../enums/processingPayments";
import { ProductWithPrice } from "../../types/stripe";

export const PROCESSING_PAYMENT_SLICE = 'processingPayment' as const;

const initialState: ProcessingPaymentSliceState = {
  state: null,
  error: null,
}

export const processingPaymentsSlice = createSlice({
  name: PROCESSING_PAYMENT_SLICE,
  initialState: initialState,
  reducers: {
    initProcessingPayment: (
      state: ProcessingPaymentSliceState,
      { payload: _ }: PayloadAction<{uid: string; subscription: any/* ; product: ProductWithPrice */}>
    ) => {},
    initProcessingPaymentSuccess: (
      state: ProcessingPaymentSliceState,
      { payload: _ }: PayloadAction<undefined>
    ) => {  
      state.state = ProcessingPaymentState.PENDING;
    },
    initProcessingPaymentError: (
      state: ProcessingPaymentSliceState,
      { payload: error }: PayloadAction<any>
    ) => {
      state.error = error;
    },
    updateProcessingPaymentState: (
      state: ProcessingPaymentSliceState,
      { payload: paymentState }: PayloadAction<ProcessingPaymentState>
    ) => {
      state.state = paymentState;
    },
    finalizeProcessingPayment: (
      state: ProcessingPaymentSliceState,
      { payload: _ }: PayloadAction<undefined>
    ) => {},
    finalizeProcessingPaymentSuccess: (
      state: ProcessingPaymentSliceState,
      { payload: _ }: PayloadAction<undefined> 
    ) => {
      state.state = null;
    },
    finalizeProcessingPaymentError: (
      state: ProcessingPaymentSliceState,
      { payload: error }: PayloadAction<any>
    ) => {
      state.error = error;
    }
  }
});

export const {
  initProcessingPayment,
  initProcessingPaymentError,
  initProcessingPaymentSuccess,
  updateProcessingPaymentState,
  finalizeProcessingPayment,
  finalizeProcessingPaymentError,
  finalizeProcessingPaymentSuccess,
} = processingPaymentsSlice.actions;

export default processingPaymentsSlice.reducer;